import { Component, OnInit } from '@angular/core';
import { environment } from '../../../assets/env/environment';

// DOCU-639: Self-registration lives in the standalone Docuty.Registration app.
// This component only forwards old /registration links to it.
export const REGISTRATION_URL = environment.IS_PRODUCTION
  ? 'https://start.docuty.de'
  : 'https://docuty-start-test.insirion.com';

@Component({
  selector: 'app-registration-redirect',
  template: `
    <div class="flex flex-col items-center justify-center min-h-screen gap-4">
      <span class="text-gray-500 dark:text-gray-300">
        {{ 'REGISTER.REDIRECT_HINT' | translate }}
      </span>
      <a [href]="registrationUrl" class="text-blue-700 hover:underline dark:text-blue-500">
        {{ registrationUrl }}
      </a>
    </div>
  `
})
export class RegistrationRedirectComponent implements OnInit {
  registrationUrl = REGISTRATION_URL;

  ngOnInit() {
    window.location.replace(REGISTRATION_URL);
  }
}
